import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";

import {
  DeleteMessagePayload,
  EncryptedMessage,
  GetMessagePayload,
  GetMessagesPayload,
  MessageType,
} from "../types/message";

export const getMessages = async (
  payload: GetMessagesPayload,
  signal?: AbortSignal,
): Promise<EncryptedMessage[]> => {
  const response = await requestApi(
    {
      url: ApiEndpoints.MESSAGES,
      method: "GET",
      params: payload,
      signal,
    },
    { retry429: true },
  );
  return response.data;
};

export const getMessage = async (
  payload: GetMessagePayload,
  signal?: AbortSignal,
): Promise<EncryptedMessage> => {
  const response = await requestApi(
    {
      url: `${ApiEndpoints.MESSAGES}/${payload.message_id}`,
      method: "GET",
      params: payload,
      signal,
    },
    { retry429: true },
  );
  return response.data;
};

export const postMessage = async (
  message_type: MessageType,
  payload: Partial<EncryptedMessage>, // ??
  signal?: AbortSignal,
): Promise<string[]> => {
  const response = await requestApi({
    url: ApiEndpoints.MESSAGES,
    method: "POST",
    params: { message_type },
    data: [payload],
    signal,
  });

  return response.data;
};

export const patchMessage = async (
  message_type: MessageType,
  payload: Partial<EncryptedMessage>, // ??
  signal?: AbortSignal,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.MESSAGES,
    method: "PATCH",
    params: { message_type },
    data: payload,
    signal,
  });
};

export const pinMessage = async (
  is_pinned: boolean,
  payload: Partial<EncryptedMessage>,
  signal?: AbortSignal,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.PIN_MESSAGE,
    method: "PATCH",
    params: { is_pinned },
    data: payload,
    signal,
  });
};

export const deleteMessage = async (
  payload: DeleteMessagePayload,
  signal?: AbortSignal,
): Promise<string[]> => {
  const response = await requestApi({
    url: `${ApiEndpoints.MESSAGES}/${payload.message_id}`,
    method: "DELETE",
    params: payload,
    signal,
  });

  return response.data;
};
